import type { LevelConfig } from "@gridflow/core";
import { OFFICIAL_LEVELS } from "./levels";
import { parseLevelJson } from "./schema";

export type LevelSource = "json";

export interface LevelCatalogEntry {
  readonly id: string;
  readonly order: number;
  readonly source: LevelSource;
  readonly teachingGoal: string;
  readonly config: LevelConfig;
}

export interface LevelCatalog {
  readonly id: string;
  readonly entries: readonly LevelCatalogEntry[];
}

export const officialLevelCatalog = {
  id: "m4-official-levels",
  entries: OFFICIAL_LEVELS.map((level) => ({
    id: level.id,
    order: level.order,
    source: "json",
    teachingGoal: level.teachingGoal,
    config: parseLevelJson(level)
  }))
} as const satisfies LevelCatalog;

export const developmentLevelCatalog = officialLevelCatalog;

export function getLevelCount(catalog: LevelCatalog): number {
  return catalog.entries.length;
}

export function getLevelById(catalog: LevelCatalog, id: string): LevelCatalogEntry | null {
  return catalog.entries.find((entry) => entry.id === id) ?? null;
}

export function getLevelByOrder(catalog: LevelCatalog, order: number): LevelCatalogEntry | null {
  return catalog.entries.find((entry) => entry.order === order) ?? null;
}

export { OFFICIAL_LEVELS } from "./levels";
export {
  LEVEL_JSON_SCHEMA,
  coordinateToPoint,
  parseLevelJson,
  pointToCoordinate,
  validateLevelJsonShape,
  type LevelCoordinate,
  type LevelJson,
  type LevelJsonNode,
  type LevelValidationIssue
} from "./schema";
export {
  validateKnownSolution,
  validateLevelCatalog,
  validateLevelJson,
  validateOfficialLevelCatalog,
  type CatalogValidationReport,
  type LevelValidationReport
} from "./validation";
